import { useMutation, useQueryClient } from '@tanstack/react-query';
import { startCancellation } from '../services/cancellation';
import type { CancelAgreementValues } from '../schemas/cancelAgreement.schema';
import { agreementKeys } from './agreementKeys';

export function useCancelAgreement(agreementId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (values: CancelAgreementValues) => startCancellation(agreementId, values),
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: agreementKeys.detail(agreementId) });
            void queryClient.invalidateQueries({ queryKey: agreementKeys.history(agreementId) });
        },
    });
}
